/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TechnicianAvailableSlots } from '../models/TechnicianAvailableSlots';
import type { WorkshopPlannerJobModel } from '../models/WorkshopPlannerJobModel';
import type { WorkshopPlannerJobSumbitModel } from '../models/WorkshopPlannerJobSumbitModel';
import type { WorkshopPlannerJobUpdateModel } from '../models/WorkshopPlannerJobUpdateModel';
import type { WorkshopPlannerWipModel } from '../models/WorkshopPlannerWipModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkshopPlannerService {

  /**
   * @param regNo 
   * @param wipNo 
   * @param branchId 
   * @param date 
   * @returns WorkshopPlannerWipModel Success
   * @throws ApiError
   */
  public static getWorkshopPlannerJobsWips(
regNo?: string,
wipNo?: number,
branchId?: number,
date?: string,
): CancelablePromise<Array<WorkshopPlannerWipModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-planner-jobs/wips',
      query: {
        'RegNo': regNo,
        'WipNo': wipNo,
        'BranchId': branchId,
        'Date': date,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopPlannerJobsWips1(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-planner-jobs/{id}/wips',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param userId 
   * @param dateFrom 
   * @param dateTo 
   * @returns WorkshopPlannerJobModel Success
   * @throws ApiError
   */
  public static getWorkshopPlannerJobs(
userId: Array<number>,
dateFrom: string,
dateTo: string,
): CancelablePromise<Array<WorkshopPlannerJobModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-planner-jobs',
      query: {
        'UserId': userId,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWorkshopPlannerJobs(
requestBody?: WorkshopPlannerJobSumbitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-planner-jobs',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns WorkshopPlannerJobModel Success
   * @throws ApiError
   */
  public static getWorkshopPlannerJobs1(
id: number,
): CancelablePromise<WorkshopPlannerJobModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-planner-jobs/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopPlannerJobs(
id: number,
requestBody?: WorkshopPlannerJobUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop-planner-jobs/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopPlannerJobs(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-planner-jobs/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param date 
   * @param jobHours 
   * @param technicianId 
   * @returns TechnicianAvailableSlots Success
   * @throws ApiError
   */
  public static getWorkshopPlannerJobsTechnicianAvailableSlots(
date?: string,
jobHours?: number,
technicianId?: number,
): CancelablePromise<TechnicianAvailableSlots> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-planner-jobs/technician-available-slots',
      query: {
        'Date': date,
        'JobHours': jobHours,
        'TechnicianId': technicianId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

}
